import React, {useEffect, useState} from 'react';
import {Button, Col, Modal, notification, Row, Spin} from "antd";
import '../modals.css';
import {companyService, distributionCenterService} from "../../../services";
import {legalEntityService} from "../../../services/legal-entity.service";
import i18n from "../../../i18n";
import ModalUploadAdditionalLegalEntityDocs from "../upload-additional-legal-entity-docs";

export default function ModalCreateOrderToConsignor({
                                                      isShow,
                                                      setNeedUpdateOrdersList,
                                                      setIsShow,
                                                      legalEntityId,
                                                      consignorId
                                                    }) {

  const [loading, setLoading] = useState(true);
  const [needUpdateDistList, setNeedUpdateDistList] = useState(true);
  const [distributionCentersList, setDistributionCentersList] = useState([]);
  const [showUploadDocsModal, setShowUploadDocsModal] = useState(false);
  const [missingDocs, setMissingDocs] = useState([]);
  const [checkingDocs, setCheckingDocs] = useState(false);

  const buttonStyle = {
    width: '290px'
  };

  const fetchDistributionCenters = () => {
    distributionCenterService.getCompaniesOnApproveOrderCreate(legalEntityId, consignorId)
      .then((response) => {
        setDistributionCentersList(response);
        setLoading(false);
        setNeedUpdateDistList(false);
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.getCompanies2'),
          description: err,
        });

        setLoading(false);
        setNeedUpdateDistList(false);
      });
  };

  const checkAndFetchDistributionCenters = () => {
    if (!legalEntityId || !consignorId) {
      return;
    }
    setLoading(true);
    setCheckingDocs(true);

    legalEntityService.checkLegalEntityDocs(legalEntityId, consignorId)
      .then((docsCheckResult) => {
        if (docsCheckResult.data && docsCheckResult.data.length > 0) {
          // Есть недостающие документы - показываем модальное окно
          setMissingDocs(docsCheckResult.data);
          setShowUploadDocsModal(true);
          setLoading(false);
        } else {
          setCheckingDocs(false);
          fetchDistributionCenters();
        }
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.error'),
          description: err,
        });
        setLoading(false);
      });
  };

  useEffect(() => {
    if (isShow && needUpdateDistList && legalEntityId && consignorId && !checkingDocs) {
      checkAndFetchDistributionCenters();
    }
  });

  const handleSendOrderToConsignor = (legalEntityId, consignorId, distCenterId) => {
    setLoading(true);

    companyService
      .createOrderToConsignor(legalEntityId, consignorId, distCenterId)
      .then(resp => {
        if (resp.code !== 400) {
          notification.success({
            message: i18n.t('components.notification.titles.createOrder'),
            description: resp.message,
          });

          window.location.reload();

          setIsShow(false);
          setNeedUpdateOrdersList(true);
          setLoading(false);
        } else {
          notification.error({
            message: i18n.t('components.notification.titles.createOrder'),
            description: resp.message,
          });
        }
      })
      .catch(errMsg => {
        notification.error({
          message: i18n.t('components.notification.titles.createOrder'),
          description: errMsg,
        });
      });
  };

  const ordersButtonsRender = () => {
    return distributionCentersList.map((distCenter) => {
      if (distCenter.IsActive) {
        return (
          <Col lg={8} sm={24}>
            <Button style={buttonStyle}
                    onClick={() => handleSendOrderToConsignor(legalEntityId, consignorId, distCenter.Id)}
                    className="small-button typical-btn-green">
              {distCenter.VisibleName}
            </Button>
          </Col>
        );
      }
    })
  };


  return (
    <>
      <Modal
        title={<span className="ant-modal-title">{i18n.t('modals.modalCreateOrderToConsignor.title')}</span>}
        cancelText={i18n.t('main.buttons.close')}
        className="modal-window"
        style={{maxWidth: '450px'}}
        align={null}
        visible={isShow}
        footer={null}
        onCancel={() => {
          setIsShow(false);
          setLoading(true);
          setNeedUpdateDistList(true);
          setCheckingDocs(false);
          setDistributionCentersList([]);
          setNeedUpdateDistList(true);
        }}
      >
        <Spin spinning={loading} tip={i18n.t('main.loadText.loading')}>
          <Row className="add-padding-10 -centered">
            {ordersButtonsRender()}
          </Row>
        </Spin>
      </Modal>

      <ModalUploadAdditionalLegalEntityDocs
        isShow={showUploadDocsModal}
        setIsShow={setShowUploadDocsModal}
        legalEntityId={legalEntityId}
        consignorId={consignorId}
        missingDocs={missingDocs}
        setCheckingDocs={setCheckingDocs}
      />
    </>
  );
}